import { render } from "./CommonLayout.vue?vue&type=template&id=2881d406"
import script from "./CommonLayout.vue?vue&type=script&lang=js"
export * from "./CommonLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__